import React from 'react';
import ExploreTagPresenter from './ExploreTagPresenter';

function ExploreTagContainer() {
    return(
      <ExploreTagPresenter />
    );
}

export default ExploreTagContainer;